import { render } from "./Card.vue?vue&type=template&id=584a82a2"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=584a82a2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__